import { getToken, resetState } from "../utils/index";

export default {
  namespaced: true,
  state: {
    error: null,
    busy: false,
    loading: false,
    refresh: false,
    initialLoad: true,
    posTransactions: {
      data: [],
    },
    posOverview: {},
  },
  mutations: {
    GET_POS_TRANSACTIONS_START: (state) => {
      state.busy = true;
      state.loading = true;
    },
    GET_POS_TRANSACTIONS_FAILED: (state, error) => {
      state.busy = false;
      state.loading = false;
      state.refresh = false;
      state.error = error;
    },
    GET_POS_TRANSACTIONS_SUCCESS: (state, posTransactions) => {
      state.busy = false;
      state.loading = false;
      state.refresh = false;
      state.posTransactions = posTransactions;
      console.log(posTransactions);
    },
    GET_POS_OVERVIEW_START: (state) => {
      state.loading = true;
    },
    GET_POS_OVERVIEW_FAILED: (state, error) => {
      state.loading = false;
      state.refresh = false;
      state.error = error;
    },
    GET_POS_OVERVIEW_SUCCESS: (state, posOverview) => {
      state.loading = false;
      state.refresh = false;
      state.initialLoad = false;
      state.posOverview = posOverview;
      console.log(posOverview);
    },
    REFRESH: (state) => {
      state.refresh = true;
    },
  },
  actions: {
    async getPosTransactions({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_POS_TRANSACTIONS_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/transactions?type=pos&start=${payload.startDate}&end=${payload.endDate}&show=20&page=${payload.page}`,
          config
        );
        const data = await response.json();
        commit("GET_POS_TRANSACTIONS_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_POS_TRANSACTIONS_FAILED", err);
      }
    },
    async getPosOverview({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_POS_OVERVIEW_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/transactions/overview?type=pos&start=${payload.startDate}&end=${payload.endDate}`,
          config
        );
        const data = await response.json();
        commit("GET_POS_OVERVIEW_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_POS_OVERVIEW_FAILED", err);
      }
    },
    async refresh({ commit }) {
      commit("REFRESH");
    },
  },
};
